export const SAVE_AUTOMATION_CUSTOMERS = 'SAVE_AUTOMATION_CUSTOMERS';
export const SAVE_AUTOMATION_CUSTOMERS_SUCCESS =
  'SAVE_AUTOMATION_CUSTOMERS_SUCCESS';
export const SAVE_AUTOMATION_CUSTOMERS_FAIL = 'SAVE_AUTOMATION_CUSTOMERS_FAIL';
export const RESET_AUTOMATION_CUSTOMERS_ERROR =
  'RESET_AUTOMATION_CUSTOMERS_ERROR';

export const saveAutomationCustomers = ({
  automationId,
  customerIds,
  deleteCustomerIds
}) => ({
  type: SAVE_AUTOMATION_CUSTOMERS,
  payload: { automationId, customerIds, deleteCustomerIds }
});

export const saveAutomationCustomersSuccess = () => ({
  type: SAVE_AUTOMATION_CUSTOMERS_SUCCESS
});

export const saveAutomationCustomersFail = (message) => ({
  type: SAVE_AUTOMATION_CUSTOMERS_FAIL,
  payload: { message }
});

export const resetAutomationCustomerError = () => ({
  type: RESET_AUTOMATION_CUSTOMERS_ERROR
});
